<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ firma }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">Umowy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ form.number }}
    </h1>

    <trashed-message v-if="contract.deleted_at" class="mb-6" @restore="restore">
      Umowa jest oznaczona jako usunięta.
    </trashed-message>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="firma" class="pr-6 pb-8 w-full" label="Klient" disabled />

            <text-input v-model="form.number" :error="form.errors.number" class="pr-6 pb-8 w-full lg:w-1/2" label="Numer" disabled />

            <div class="w-full lg:w-1/2"></div>

            <multiselect-input v-model="form.theme" :error="form.errors['theme.id']" label="Szablon" :options="themes" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />

            <div class="pr-6 pb-8 w-full lg:w-1/2"></div>

            <multiselect-input v-model="form.price_list" :error="form.errors['price_list.id']" label="Cennik usług księgowych" :options="price_lists" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />

            <multiselect-input v-model="form.price_list_kadry" :error="form.errors['price_list_kadry.id']" label="Cennik usługi kadrowej" :options="price_lists_kadry" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />


            <shtax-checkbox class="pr-6 pb-8 w-full" v-model:checked.sync="form.has_promotion" :error="form.errors.has_promotion" :checked="form.has_promotion" label="Dodaj cennik promocyjny"  />
            <multiselect-input v-model="form.promotion_price_list" :error="form.errors['promotion_price_list.id']" label="Cennik promocyjny usług księgowych" :options="price_lists" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" :isDisabled="!form.has_promotion" />
            <text-input v-model="form.promotion_ends_on" :error="form.errors.promotion_ends_on" class="pr-6 pb-8 w-full lg:w-1/2" label="Zakończenie promocji" type="date" :disabled="!form.has_promotion" />

            <text-input v-model="form.signed_at" :error="form.errors.signed_at" class="pr-6 pb-8 w-full lg:w-1/2" label="Data podpisania (zawarcia)" type="date" />

            <text-input v-model="form.service_start_on" :error="form.errors.service_start_on" class="pr-6 pb-8 w-full lg:w-1/2" label="Data rozpoczęcia świadczenia usług" type="date" />

            <text-input v-model="form.started_from" :error="form.errors.started_from" class="pr-6 pb-8 w-full lg:w-1/2" label="Pierwszy miesiąc" type="date" />

            <file-input v-model="form.contract_file" :error="form.errors.contract_file" class="pr-6 pb-8 w-full" type="file" accept="application/pdf" label="Skan umowy" v-if="!contract.contract_path" />

            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.notice" :error="form.errors.notice" label="Uwagi"  />
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <button v-if="!contract.deleted_at && $page.props.can['delete contracts']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="destroy">Usuń umowę</button>
            <button v-if="contract.deleted_at && $page.props.can['hard delete contracts']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="hardDestroy">Usuń całkowicie</button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zaktualizuj dane</loading-button>
          </div>
        </form>
      </div>

      <div class="mt-12 lg:mt-0 lg:px-8 w-full lg:w-1/2" v-if="contract.contract_path">
        <h3 class="mb-2 font-bold text-lg md:text-md ">
          Skan umowy 
          <button class="btn-shtax px-3 py-1.5 text-xs float-right bg-red-600" @click="remove_file">
            <fa :icon="['far', 'trash-alt']" class="w-4 h-4 pt-1 mr-1" fixed-width /> Usuń
          </button>
        </h3>
        <div class="mt-2 bg-white rounded shadow overflow-x-auto text-sm">
          <embed :src="'/preview/' + contract.contract_path" width="100%" height="480" type='application/pdf'>
        </div>
      </div>
    
    </div>

    <h2 class="mt-12 font-bold text-xl md:text-2xl relative">
        Definicje faktur
        <div class="inline">
            <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('factures.create', client.id)" v-if="!client.deleted_at && !contract.deleted_at">
              <span>Nowa</span>
              <span class="hidden md:inline">faktura</span>
            </inertia-link>
        </div>
    </h2>
    
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">#</th>
          <th class="px-6 pt-6 pb-4">Magazyn</th>
          <th class="px-6 pt-6 pb-4">Blokada wystawiania</th>
          <th class="px-6 pt-6 pb-4">Forma płatności</th>
          <th class="px-6 pt-6 pb-4">Liczba pozycji</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Uwagi</th>
        </tr>
        <tr v-for="facture in contract.factures" :key="facture.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':facture.is_blocked}">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.id }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.magazyn.NAZWA }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.is_blocked ? 'Tak' : 'Nie' }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.forma_platnosci.NAZWA }} ({{ facture.forma_platnosci.DNI_NALEZNOSCI }} dni)
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.positions.length }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})">
              <span>
                {{ facture.uwagi }}
              </span>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('factures.edit', {'client':client.id, 'facture':facture.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="contract.factures.length === 0">
          <td class="border-t px-6 py-4" colspan="8">Brak zdefiniowanych faktur.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/ShtaxComponents/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return {
      title: `${this.form.number}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput,
    TrashedMessage,
    FileInput,
    Icon
  },
  layout: Layout,
  props: {
    client: Object,
    contract: Object,
    price_lists: Array,
    price_lists_kadry: Array,
    themes: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'PUT',
        number: this.contract.number,
        price_list: this.contract.price_list,
        signed_at: this.contract.signed_at,
        started_from: this.contract.started_from,
        notice: this.contract.uwagi,
        contract_file: null,
        theme: this.contract.theme,
        price_list_kadry: this.contract.price_list_kadry,
        has_promotion: this.contract.has_promotion,
        promotion_price_list: this.contract.promotion_price_list,
        promotion_ends_on: this.contract.promotion_ends_on,
        service_start_on: this.contract.service_start_on
      }),
    }
  },
  methods: {
    update() {
      this.form.post('/clients/'+ this.client.id +'/contracts/'+ this.contract.id)
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz usunąć wybraną umowę kontrahenta?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('contracts.destroy', {'client':this.client.id, 'contract':this.contract.id}))
        }
      })
    },
    hardDestroy() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz usunąć całkowicie wybraną umowę kontrahenta?',
        text: 'Przywrócenie usuniętej umowy nie będzie już możliwe',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń całkowicie!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('contracts.harddestroy', {'client':this.client.id, 'contract':this.contract.id, 'force':1}))
        }
      })
    },
    restore() {
      Swal.fire({
        title: 'Jesteś pewny że chcesz przywrócić wybraną umowę?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, odblokuj!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(this.route('contracts.restore', {'client':this.client.id, 'contract':this.contract.id}))
        }
      })
    },
    remove_file() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz usunąć skan umowy?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(this.route('contracts.remove_file', {'client':this.client.id, 'contract':this.contract.id}))
        }
      })
    },
    // activate() {
    //  if (confirm('Jesteś pewien że chcesz aktywować wybraną umowę kontrahenta?')) {
    //    console.log('activating')
    //  }
    // },
  },

  computed: {
    firma() {
      return this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna
    }
  }
}
</script>
